import React from "react";
import { renderRoutes } from "react-router-config";
import Layout from "layouts";

const Subscriptions = (props: any): JSX.Element => {
  return <Layout>{renderRoutes(props.route.routes)}</Layout>;
};

export default Subscriptions;
